<script setup lang="ts">
import { setErrors, clearErrors } from '@formkit/core'

const runtimeConfig = useRuntimeConfig()
interface Submit {
  storefrontUrl: string,
  firstName: string,
  lastName: string,
  phoneNumber: string,
  email: string,
  password: string
}
const { signUp } = useAuth()
const { t, te } = useI18n()
const submit = async (data: Submit) => {
  const { email, firstName } = data
  data.storefrontUrl = runtimeConfig.public.storefrontUrl
  clearErrors('register-form')
  try {
   await signUp(data, { callbackUrl: '/u/moje-konto' })

    if (data.newsletter) {
      await newsletter({ email, firstName })
    }
  } catch (e: any) {
    const errors = e.data.data.errors
    if (errors && errors.length > 0) {
      const errorMessage = te(errors[0].code) ? t(errors[0].code) : errors[0].detail;
      setErrors('register-form', errorMessage);
    } else {
      setErrors('register-form', JSON.stringify(e));
    }
  }
}
</script>

<template>
  <FormKit
    type="form"
    id="register-form"
    :actions="false"
    :incomplete-message="false"
    @submit="submit"
  >
    <FormKit
      type="text"
      outer-class="mb-[10px]"
      name="firstName"
      label="Imię*"
      placeholder="Imię*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole imię nie może być puste.'
      }"
    />
    <FormKit
      type="text"
      outer-class="mb-[10px]"
      name="lastName"
      label="Nazwisko*"
      placeholder="Nazwisko*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole nazwisko nie może być puste.'
      }"
    />
    <FormKit
      type="text"
      outer-class="mb-[10px]"
      name="phoneNumber"
      label="Numer telefonu*"
      placeholder="Numer telefonu*"
      validation="required|phone"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole numer telefonu nie może być puste.',
        phone: 'Numer telefonu jest błędny.'
      }"
    />
    <FormKit
      type="email"
      outer-class="mb-[10px]"
      name="email"
      label="E-mail*"
      placeholder="E-mail*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole e-mail nie może być puste.'
      }"
    />
    <FormKit
      type="password"
      outer-class="mb-[10px]"
      name="password"
      label="Hasło*"
      placeholder="Hasło*"
      validation="required"
      validation-visibility="blur"
      :validation-messages="{
        required: 'Pole hasło nie może być puste.'
      }"
    />
    <div class="text-gray-500 text-12">
      * Pole wymagane
    </div>
    <FormKit
      type="checkbox"
      outer-class="mb-[10px]"
      name="terms_and_conditions_personal_data"
      validation="accepted"
      validation-visibility="blur"
      :validation-messages="{
        accepted: 'Zaakceptuj regulamin.'
      }"
    >
      <template #suffix>
        <div>Akceptuję <NuxtLink to="/i/regulamin" target="_blank" class="underline">regulamin</NuxtLink> sklepu*</div>
      </template>
    </FormKit>
    <FormKit
      type="checkbox"
      outer-class="mb-[10px]"
      name="terms_and_conditions_privacy_policy"
      validation="accepted"
      validation-visibility="blur"
      :validation-messages="{
        accepted: 'Zaakceptuj regulamin.'
      }"
    >
      <template #suffix>
      <div>Wyrażam zgodę na przetwarzanie moich danych osobowych podanych w formularzu przez EMOTIVO sp. z o.o w Puławach (24-100), ul. 6 Sierpnia 1, w sposób opisany w <NuxtLink to="/i/polityka-prywatnosci" target="_blank" class="underline">polityce prywatnośći</NuxtLink> w celu złożenia zamówienia.*</div>
      </template>
    </FormKit>
    <FormKit
      type="checkbox"
      outer-class="mb-[10px]"
      name="newsletter"
    >
      <template #suffix>
      <div>Wyrażam zgodę na otrzymywanie newslettera, informacji handlowych o produktach i usługach oferowanych przez EMOTIVO sp. z o. o. i zapoznałem/zapoznałam się z <NuxtLink to="/i/polityka-prywatnosci" target="_blank" class="underline">polityką prywatności</NuxtLink>.</div>
      </template>
    </FormKit>
    <FormKit
      type="submit"
      input-class="btn btn-action btn-lg mb-[10px]"
    >
      <span class="text-16">Utwórz konto</span>
      <i class="icon-arrow-button text-[10px]" />
    </FormKit>
  </FormKit>
</template>
